import { z } from 'zod';
export const Contact = z.object({
    id: z.string(),
    name: z.string().max(80),
    role: z.string().max(80),
    phone: z.string().max(40),
    note: z.string().max(200),
});
export const InfoSection = z.object({
    id: z.string(),
    title: z.string().max(80),
    icon: z.string().max(40),
    /** Plain text. Blank lines split paragraphs; lines starting "- " are bullets. */
    body: z.string().max(4000),
});
export const HouseInfo = z.object({
    /** Shown above everything else on the guest's Info tab. */
    contacts: z.array(Contact).max(12),
    sections: z.array(InfoSection).max(30),
    updatedAt: z.iso.datetime().nullable(),
});
export const EMPTY_HOUSE_INFO = { contacts: [], sections: [], updatedAt: null };
/**
 * Seeded on first run so the owner edits prompts rather than facing a blank
 * page. Every prompt is specific to this house — the automations that will
 * alarm a sitter, the zones that exist, the things with no sensor to read.
 */
export const STARTER_SECTIONS = [
    {
        title: 'If something goes wrong',
        icon: 'info',
        body: 'Call me first — any hour, genuinely.\n\nIf you cannot reach me, the neighbour holds a spare key.\n\n- Water everywhere: turn the stopcock off first, then call.\n- Smell of gas: everyone out, then 0800 111 999 from outside.',
    },
    {
        title: "Looks broken but isn't",
        icon: 'sparkle',
        body: 'The house does a lot by itself. None of this needs action:\n\n- Lights come on and go off on their own, on a schedule and on motion.\n- The garage door opens by itself so the robot vacuum can get out, and shuts behind it.\n- The alarm can disarm itself if one of our phones looks like it is home.\n- The battery charges hard in the early hours. The house will be drawing a lot at 2am. That is deliberate.',
    },
    {
        title: 'Alarm',
        icon: 'shield',
        body: 'Disarm and arm it from this app — you do not need the keypad or the code.\n\nThere is a delay on the way in and on the way out, so it will beep before it does anything.\n\nIf it goes off: disarm it in the app, then call me.',
    },
    {
        title: 'Heating & hot water',
        icon: 'radiator',
        body: 'Every room sets its own temperature — use the room in this app rather than the wall thermostats.\n\nHot water looks after itself. Please leave the cylinder and the immersion alone; if you run out, tell me and I will boost it remotely.',
    },
    {
        title: 'Bins',
        icon: 'power',
        body: 'Collection day:\n\nWhich bin goes out when:\n\nBins live:',
    },
    {
        title: 'Post & deliveries',
        icon: 'door',
        body: 'The doorbell rings through to this app, so you will see it even in the garden.\n\nParcels can be left:\n\nPost goes:',
    },
    {
        title: 'Watering',
        icon: 'tree',
        body: 'The garden waters itself on a timer.\n\nPlants that need doing by hand:',
    },
    {
        title: 'Cars & garage',
        icon: 'key',
        body: 'Please do not unplug or move the cars.\n\nThe garage door:',
    },
    {
        title: 'Where things are',
        icon: 'home',
        body: '- Stopcock:\n- Fuse box:\n- Spare keys:\n- First aid kit:\n- Fire extinguisher:\n- Meters:',
    },
    {
        title: 'House rules',
        icon: 'check',
        body: 'Shoes off please.\n\nAnything else worth knowing:',
    },
];
//# sourceMappingURL=info.js.map